import { PLACES_AUTOCOMPLETE_FEATURE_FLAG } from '@act/shared/data-transfer-objects';
import { useFeatureFlag } from 'redux/utils/feature-flags/featureFlagHook.hook';

/**
 * Whether Google Places autocomplete and CBO resource UI are enabled for the acting user.
 *
 * @returns True when {@link PLACES_AUTOCOMPLETE_FEATURE_FLAG} is on.
 */
export function usePlacesAutocompleteEnabled(): boolean {
  return useFeatureFlag(PLACES_AUTOCOMPLETE_FEATURE_FLAG);
}
